import type { CreateTypePropertyInput, UpdateTypePropertyInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type {
  PaginatedTypeProperties,
  TypePropertiesAdminParams,
  TypePropertyAdminRow
} from '../models/type-property-admin'

export async function getTypePropertiesAdmin(
  params: TypePropertiesAdminParams
): Promise<PaginatedTypeProperties> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedTypeProperties>(
    `${API.typeProperties.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createTypeProperty(
  payload: CreateTypePropertyInput
): Promise<TypePropertyAdminRow> {
  const { data } = await axiosPrivate.post<TypePropertyAdminRow>(API.typeProperties.root, payload)
  return data
}

export async function updateTypeProperty(
  id: string,
  payload: UpdateTypePropertyInput
): Promise<TypePropertyAdminRow> {
  const { data } = await axiosPrivate.patch<TypePropertyAdminRow>(
    API.typeProperties.byId(id),
    payload
  )
  return data
}

export async function deleteTypeProperty(id: string) {
  const { data } = await axiosPrivate.delete(API.typeProperties.byId(id))
  return data
}
